if (typeof window !== 'undefined') {
  var currentEnv = (typeof process !== 'undefined' && process.env && process.env.NODE_ENV)
    ? process.env.NODE_ENV
    : 'production';

  window.process = window.process || {};
  window.process.env = window.process.env || {};
  if (!window.process.env.NODE_ENV) {
    window.process.env.NODE_ENV = currentEnv;
  }
  window.process.browser = true;
  window.process.version = window.process.version || '';
  window.process.versions = window.process.versions || {};
  window.process.platform = window.process.platform || 'browser';
  window.process.nextTick = window.process.nextTick || function(fn) { setTimeout(fn, 0); };
}
